/* Pivot (oct. 2026) : plans techniques des racks de toit dans l'onglet "Dimensions"
   + visionneuse plein ecran sur la meme page (zoom molette, pincement, double-clic, glisser).
   Plans par modele (Shopify Files) : Sprinter, Transit, Promaster.
   Remplace les anciennes images de plan deja presentes dans l'onglet. */
(function () {
  var PLANS = {
    sprinter: 'https://cdn.shopify.com/s/files/1/0665/1291/2592/files/plan-rack-sprinter.png?v=1792012395',
    transit: 'https://cdn.shopify.com/s/files/1/0665/1291/2592/files/plan-rack-transit.png?v=1792012395',
    promaster: 'https://cdn.shopify.com/s/files/1/0665/1291/2592/files/plan-rack-promaster.png?v=1792012395'
  };
  var handle = window.PivotProductHandle || '';
  if (handle.indexOf('roof-rack') === -1) return;
  var model = handle.indexOf('sprinter') !== -1 ? 'sprinter' : handle.indexOf('transit') !== -1 ? 'transit' : handle.indexOf('promaster') !== -1 ? 'promaster' : '';
  if (!model) return;
  var src = PLANS[model];
  var fr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var T = fr
    ? { tab: 'Dimensions et poids', hint: 'Cliquez sur le plan pour l’agrandir et zoomer', alt: 'Plan technique du rack de toit ' + model + ' : dimensions et fixation', close: 'Fermer', zin: 'Zoom avant', zout: 'Zoom arrière', help: 'Molette ou pincement pour zoomer · glisser pour déplacer · double-clic pour zoomer ici' }
    : { tab: 'Dimensions & Weight', hint: 'Click the drawing to enlarge and zoom', alt: 'Roof rack technical drawing for ' + model + ': dimensions and mounting', close: 'Close', zin: 'Zoom in', zout: 'Zoom out', help: 'Scroll or pinch to zoom · drag to move · double-click to zoom there' };

  var css = '' +
    '.pv-plan-wrap button.pv-plan{display:block;width:100%;height:auto !important;min-height:0 !important;max-height:none !important;padding:0 !important;margin:0;border:1px solid rgba(31,26,16,.12);border-radius:6px;background:#fff;cursor:zoom-in;overflow:hidden;line-height:0;box-shadow:none;transform:none}' +
    '.pv-plan-wrap button.pv-plan::before,.pv-plan-wrap button.pv-plan::after{display:none !important}' +
    '.pv-plan-wrap button.pv-plan img{display:block;width:100%;height:auto;max-width:100%;margin:0}' +
    '.pv-plan__hint{display:flex;align-items:center;justify-content:center;gap:6px;margin:8px 0 0;font-size:13px;color:rgba(31,26,16,.65)}' +
    '.pv-lb{position:fixed;inset:0;z-index:2147483000;background:#fff;display:flex;flex-direction:column}' +
    '.pv-lb__bar{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 14px;border-bottom:1px solid rgba(31,26,16,.1);font-size:13px;color:rgba(31,26,16,.7)}' +
    '.pv-lb__tools{display:flex;align-items:center;gap:8px}' +
    '.pv-lb button.pv-lb__btn{width:40px;height:40px !important;min-height:0 !important;padding:0 !important;display:inline-flex;align-items:center;justify-content:center;border:1px solid rgba(31,26,16,.18);border-radius:50%;background:#fff;color:#1f1a10;cursor:pointer}' +
    '.pv-lb button.pv-lb__btn:hover{background:#f3f2ee}' +
    '.pv-lb__pct{min-width:48px;text-align:center;font-variant-numeric:tabular-nums;color:#1f1a10}' +
    '.pv-lb__stage{position:relative;flex:1;overflow:hidden;touch-action:none;cursor:grab;background:#fff}' +
    '.pv-lb__stage.is-dragging{cursor:grabbing}' +
    '.pv-lb__img{position:absolute;left:0;top:0;transform-origin:0 0;max-width:none !important;width:auto !important;height:auto !important;user-select:none;-webkit-user-drag:none}' +
    '.pv-lb__help{flex:1;text-align:center}' +
    '@media (max-width:767px){.pv-lb__help{display:none}}' +
    'html.pv-lb-open,html.pv-lb-open body{overflow:hidden}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var ICON_ZOOM = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';

  /* ---------- Visionneuse ---------- */
  function openViewer() {
    var lb = document.createElement('div');
    lb.className = 'pv-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<div class="pv-lb__bar">' +
        '<div class="pv-lb__tools">' +
          '<button type="button" class="pv-lb__btn" data-a="out" aria-label="' + T.zout + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>' +
          '<span class="pv-lb__pct">100%</span>' +
          '<button type="button" class="pv-lb__btn" data-a="in" aria-label="' + T.zin + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>' +
        '</div>' +
        '<span class="pv-lb__help">' + T.help + '</span>' +
        '<button type="button" class="pv-lb__btn" data-a="close" aria-label="' + T.close + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg></button>' +
      '</div>' +
      '<div class="pv-lb__stage"><img class="pv-lb__img" alt="' + T.alt + '" draggable="false"></div>';
    document.body.appendChild(lb);
    document.documentElement.classList.add('pv-lb-open');

    var stage = lb.querySelector('.pv-lb__stage');
    var img = lb.querySelector('.pv-lb__img');
    var pct = lb.querySelector('.pv-lb__pct');
    var s = 1, x = 0, y = 0, fit = 1, maxS = 1;

    function apply() {
      img.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + s + ')';
      pct.textContent = Math.round((s / fit) * 100) + '%';
    }
    function clamp() {
      var sw = stage.clientWidth, sh = stage.clientHeight;
      var w = img.naturalWidth * s, h = img.naturalHeight * s;
      x = w <= sw ? (sw - w) / 2 : Math.min(0, Math.max(sw - w, x));
      y = h <= sh ? (sh - h) / 2 : Math.min(0, Math.max(sh - h, y));
    }
    function zoomAt(ns, cx, cy) {
      ns = Math.max(fit, Math.min(maxS, ns));
      x = cx - (cx - x) * (ns / s);
      y = cy - (cy - y) * (ns / s);
      s = ns;
      clamp();
      apply();
    }
    function reset() {
      var sw = stage.clientWidth, sh = stage.clientHeight;
      fit = Math.min(sw / img.naturalWidth, sh / img.naturalHeight) * 0.96;
      maxS = Math.max(fit * 8, 1.5);
      s = fit;
      clamp();
      apply();
    }
    img.onload = reset;
    img.src = src;

    function close() {
      document.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', reset);
      document.documentElement.classList.remove('pv-lb-open');
      lb.remove();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === '+' || e.key === '=') zoomAt(s * 1.4, stage.clientWidth / 2, stage.clientHeight / 2);
      if (e.key === '-') zoomAt(s / 1.4, stage.clientWidth / 2, stage.clientHeight / 2);
    }
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', reset);

    lb.querySelector('.pv-lb__bar').addEventListener('click', function (e) {
      var b = e.target.closest('[data-a]');
      if (!b) return;
      var a = b.getAttribute('data-a');
      if (a === 'close') close();
      if (a === 'in') zoomAt(s * 1.5, stage.clientWidth / 2, stage.clientHeight / 2);
      if (a === 'out') zoomAt(s / 1.5, stage.clientWidth / 2, stage.clientHeight / 2);
    });

    function local(e) {
      var r = stage.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var p = local(e);
      zoomAt(s * (e.deltaY < 0 ? 1.15 : 1 / 1.15), p.x, p.y);
    }, { passive: false });
    stage.addEventListener('dblclick', function (e) {
      var p = local(e);
      zoomAt(s > fit * 1.05 ? fit : fit * 3, p.x, p.y);
    });

    var pts = {}, last = null, pinch = null, lastTap = 0;
    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture(e.pointerId);
      pts[e.pointerId] = local(e);
      var ids = Object.keys(pts);
      if (ids.length === 1) {
        last = pts[e.pointerId];
        stage.classList.add('is-dragging');
        if (e.pointerType === 'touch') {
          var now = Date.now();
          if (now - lastTap < 300) zoomAt(s > fit * 1.05 ? fit : fit * 3, last.x, last.y);
          lastTap = now;
        }
      } else if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), s: s };
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = local(e);
      var ids = Object.keys(pts);
      if (ids.length === 2 && pinch) {
        var a = pts[ids[0]], b = pts[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        zoomAt(pinch.s * (d / pinch.d), (a.x + b.x) / 2, (a.y + b.y) / 2);
      } else if (ids.length === 1 && last) {
        var p = pts[e.pointerId];
        x += p.x - last.x;
        y += p.y - last.y;
        last = p;
        clamp();
        apply();
      }
    });
    function up(e) {
      delete pts[e.pointerId];
      var ids = Object.keys(pts);
      if (ids.length < 2) pinch = null;
      if (ids.length === 1) last = pts[ids[0]];
      if (ids.length === 0) { last = null; stage.classList.remove('is-dragging'); }
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
  }

  /* ---------- Onglet Dimensions ---------- */
  function buildPlan() {
    var wrap = document.createElement('div');
    wrap.className = 'pv-plan-wrap';
    wrap.innerHTML =
      '<button type="button" class="pv-plan" aria-label="' + T.hint + '">' +
        '<img src="' + src + '&width=1200" srcset="' + src + '&width=800 800w, ' + src + '&width=1200 1200w, ' + src + '&width=1800 1800w" sizes="(max-width: 767px) 100vw, 500px" alt="' + T.alt + '">' +
      '</button>' +
      '<p class="pv-plan__hint">' + ICON_ZOOM + T.hint + '</p>';
    wrap.querySelector('.pv-plan').addEventListener('click', openViewer);
    return wrap;
  }

  function removeOldPlans(content) {
    Array.prototype.slice.call(content.querySelectorAll('img')).forEach(function (im) {
      if (im.closest('.pv-plan-wrap')) return;
      var a = im.closest('a');
      var fig = im.closest('figure');
      var el = (a && content.contains(a)) ? a : (fig && content.contains(fig)) ? fig : im;
      el.remove();
    });
    Array.prototype.slice.call(content.querySelectorAll('p')).forEach(function (p) {
      if (p.closest('.pv-plan-wrap')) return;
      var t = p.textContent;
      if ((/plan|drawing/i.test(t) && /clique|click/i.test(t)) || (!t.trim() && !p.querySelector('img'))) p.remove();
    });
  }

  function install() {
    var root = document.querySelector('product-info') || document;
    if (root.querySelector('.pv-plan-wrap')) return;
    var details = Array.prototype.slice.call(root.querySelectorAll('details.accordion-details'));
    var dim = details.filter(function (d) {
      var h = d.querySelector('summary');
      return h && /dimension/i.test(h.textContent);
    })[0];

    if (dim) {
      var content = dim.querySelector('.accordion-details__content') || dim;
      removeOldPlans(content);
      content.insertBefore(buildPlan(), content.firstChild);
      return;
    }

    /* Pas d'onglet Dimensions : on en cree un en copiant un onglet existant */
    var model0 = details[0];
    if (!model0) return;
    var block = model0.closest('.product__block') || model0;
    var clone = block.cloneNode(true);
    var d = clone.matches('details') ? clone : clone.querySelector('details');
    d.removeAttribute('open');
    d.setAttribute('aria-expanded', 'false');
    d.id = 'Details-pv-dimensions';
    var h2 = d.querySelector('summary h2');
    if (h2) h2.textContent = T.tab;
    var c = d.querySelector('.accordion-details__content');
    if (c) { c.innerHTML = ''; c.appendChild(buildPlan()); }
    block.parentNode.insertBefore(clone, block.nextSibling);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install);
  else install();
  window.addEventListener('load', install);
})();
